document.addEventListener('DOMContentLoaded', () => {
  // Sticky Nav
  const nav = document.getElementById('main-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // Mobile Menu Toggle
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('active');
      hamburger.classList.toggle('active');
    });
  }

  // Active Link Highlight
  const currentPath = window.location.pathname;
  document.querySelectorAll('.nav-links a').forEach(link => {
    if (link.getAttribute('href') === currentPath) link.classList.add('active');
  });

  // Reveal Observer
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('active'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  // Hero Text Animation
  const initHeroAnimation = () => {
    let dynamicWord = document.getElementById('dynamic-word');
    const heroContainer = document.querySelector('.hero-animated-text');
    if (!dynamicWord || !heroContainer) return;

    if (document.body.classList.contains('index')) document.body.classList.add('no-scroll');

    const words = ["Art.", "Style.", "Visionz."];
    let currentIndex = 0;

    const stepAnimation = () => {
      currentIndex++;
      if (currentIndex < words.length) {
        setTimeout(() => {
          dynamicWord.classList.add('word-out');
          const nextWord = document.createElement('span');
          nextWord.innerText = words[currentIndex];
          nextWord.className = 'dynamic-word word-in';
          if (words[currentIndex] === "Visionz.") nextWord.classList.add('gold');
          dynamicWord.parentElement.appendChild(nextWord);
          setTimeout(() => {
            dynamicWord.remove();
            dynamicWord = nextWord;
            dynamicWord.classList.remove('word-in');
            setTimeout(stepAnimation, 700);
          }, 400);
        }, 200);
      } else {
        setTimeout(() => {
          heroContainer.classList.add('is-final');
          const heroCtas = document.querySelector('.hero-ctas');
          if (heroCtas) {
            setTimeout(() => {
              heroCtas.classList.add('is-visible');
              document.body.classList.remove('no-scroll');
            }, 400);
          } else {
            document.body.classList.remove('no-scroll');
          }
        }, 600);
      }
    };
    setTimeout(stepAnimation, 600);
  };

  // Carousel
  const initCarousel = () => {
    document.querySelectorAll('.carousel-container').forEach(container => {
      const slides = Array.from(container.querySelectorAll('.carousel-slide'));
      const nextBtn = container.querySelector('.next-btn');
      const prevBtn = container.querySelector('.prev-btn');
      const dots = Array.from(container.querySelectorAll('.dot'));
      if (slides.length === 0) return;

      let currentIndex = 0;
      let autoCycleInterval = null;

      const setSlide = (index) => {
        slides.forEach((s, i) => s.classList.toggle('active', i === index));
        dots.forEach((d, i) => d.classList.toggle('active', i === index));
        currentIndex = index;
      };
      const stopAutoCycle = () => { if (autoCycleInterval) clearInterval(autoCycleInterval); };
      const startAutoCycle = () => { stopAutoCycle(); autoCycleInterval = setInterval(() => setSlide((currentIndex + 1) % slides.length), 5000); };
      const resetAutoCycle = () => { stopAutoCycle(); startAutoCycle(); };

      new IntersectionObserver((entries) => {
        entries.forEach(e => e.isIntersecting ? startAutoCycle() : stopAutoCycle());
      }, { threshold: 0.1 }).observe(container);

      nextBtn?.addEventListener('click', () => { setSlide((currentIndex + 1) % slides.length); resetAutoCycle(); });
      prevBtn?.addEventListener('click', () => { setSlide((currentIndex - 1 + slides.length) % slides.length); resetAutoCycle(); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => { setSlide(i); resetAutoCycle(); }));
      startAutoCycle();
    });
  };

  // About Tabs
  const initAboutTabs = () => {
    const tabs = document.querySelectorAll('.hero-tab');
    const sections = document.querySelectorAll('.about-content-section');
    if (tabs.length === 0) return;

    const activateTab = (target, skipScroll = false) => {
      tabs.forEach(t => t.classList.toggle('active', t.getAttribute('data-target') === target));
      sections.forEach(s => {
        s.classList.toggle('active', s.id === `${target}-content`);
        if (s.id === `${target}-content`) {
          s.querySelectorAll('.reveal').forEach(el => { el.classList.remove('active'); setTimeout(() => el.classList.add('active'), 50); });
        }
      });
      if (!skipScroll) {
        const contentTop = document.querySelector('.hero-section.tri-split')?.offsetHeight || 0;
        if (contentTop > 0) window.scrollTo({ top: contentTop - 80, behavior: 'smooth' });
      }
    };

    tabs.forEach(tab => tab.addEventListener('click', () => activateTab(tab.getAttribute('data-target'), true)));
    const handleHash = () => {
      const hash = window.location.hash.replace('#', '');
      if (['story', 'brands', 'team'].includes(hash)) setTimeout(() => activateTab(hash), 100);
    };
    handleHash();
    window.addEventListener('hashchange', handleHash);
  };

  // Services scroll (hash-based)
  const initServicesScroll = () => {
    if (!document.body.classList.contains('services-page')) return;
    const scrollToCenter = (el) => {
      const r = el.getBoundingClientRect();
      window.scrollTo({ top: r.top + window.scrollY + r.height / 2 - window.innerHeight / 2, behavior: 'smooth' });
    };
    const handleHash = () => {
      const hash = window.location.hash;
      if (hash) { const t = document.querySelector(hash); if (t) setTimeout(() => scrollToCenter(t), 150); }
    };
    handleHash();
    window.addEventListener('hashchange', handleHash);
    document.querySelectorAll('.dropdown-menu a').forEach(link => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (href.includes('#') && document.body.classList.contains('services-page')) {
          const hash = href.split('#')[1];
          const target = document.getElementById(hash);
          if (target) { e.preventDefault(); scrollToCenter(target); history.pushState(null, null, `#${hash}`); }
        }
      });
    });
  };

  // Accordion
  const initAccordion = () => {
    document.querySelectorAll('.accordion').forEach(accordion => {
      accordion.querySelectorAll('.accordion-item').forEach(item => {
        item.querySelector('.accordion-header').addEventListener('click', () => {
          const isActive = item.classList.contains('active');
          accordion.querySelectorAll('.accordion-item').forEach(i => {
            i.classList.remove('active');
            i.querySelector('.accordion-content').style.maxHeight = null;
          });
          if (!isActive) {
            item.classList.add('active');
            const content = item.querySelector('.accordion-content');
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        });
      });
    });
  };

  initAccordion();
  initHeroAnimation();
  initAboutTabs();
  initServicesScroll();
  initCarousel();

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.reveal').forEach(el => el.classList.add('active'));
    initAccordion();
    initCarousel();
  });

  const playOnInteraction = () => {
    document.querySelectorAll('video[autoplay]').forEach(v => { if (v.paused) v.play().catch(() => {}); });
    document.removeEventListener('touchstart', playOnInteraction);
    document.removeEventListener('click', playOnInteraction);
  };
  document.addEventListener('touchstart', playOnInteraction, { passive: true });
  document.addEventListener('click', playOnInteraction);
});
